import React, { useEffect } from 'react';
import { ContentCollectionType } from '../../API';
import MixedCollections from './CollectionWrappers/MixedCollections';
import VODCollections from './CollectionWrappers/VODCollections';
import Top10Collections from './CollectionWrappers/Top10Collections';
import { useCollectionDisplay } from '../../hooks/Collections';
import { CollectionRouteContext, CollectionRouteKind } from './CollectionRouteContext';

interface CollectionsWrapperProps {
  collectionType?: ContentCollectionType;
}

export default function CollectionsWrapper({ collectionType }: CollectionsWrapperProps): JSX.Element {
  const { initialize } = useCollectionDisplay(collectionType);

  const routeKind: CollectionRouteKind =
    collectionType === ContentCollectionType.MIXED_LIST
      ? 'mixed'
      : collectionType === ContentCollectionType.TOP_10
        ? 'top10'
        : 'vod';

  useEffect(() => {
    initialize();
  }, [collectionType]);

  const inner =
    collectionType === ContentCollectionType.MIXED_LIST ? (
      <MixedCollections />
    ) : collectionType === ContentCollectionType.TOP_10 ? (
      <Top10Collections />
    ) : (
      <VODCollections />
    );

  return <CollectionRouteContext.Provider value={routeKind}>{inner}</CollectionRouteContext.Provider>;
}
